import { render, staticRenderFns } from "./ExpiryDateBadge.vue?vue&type=template&id=64717ede&"
import script from "./ExpiryDateBadge.vue?vue&type=script&lang=js&"
export * from "./ExpiryDateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports